import "../styles.css";

const ParagraphOne = () => {
  return <div className="par-one-loader-container"></div>;
};

export default ParagraphOne;
